import React, { useEffect } from 'react';
import { Col, Form, InputNumber, Modal, Row, Select } from 'antd';
import { PhoneType } from '../../interfaces/card-holder';
import { Countries } from '../../constants';
import { PhoneFormInputs } from './phones';

interface PhoneCreateFormProps {
  open: boolean;
  onCreate: (values: PhoneFormInputs) => void;
  onCancel: () => void;
  phone?: PhoneFormInputs | undefined;
}

const ModalPhones: React.FC<PhoneCreateFormProps> = ({ open, onCreate, onCancel, phone }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldValue('type', phone?.type);
    form.setFieldValue('number', phone?.number);
    form.setFieldValue('country', phone?.country);
    form.setFieldValue('areaCode', phone?.areaCode);
  }, [phone]);
  return (
    <Modal
      open={open}
      title={phone ? 'Modificar telefono' : 'Crear nuevo telefono'}
      okText={phone ? 'Modificar' : 'Crear'}
      cancelText="Cancelar"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.error('Validate Failed:', info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="form_in_modal">
      <Row>
          <Col span={24}>
              <Form.Item<PhoneFormInputs>
              name="type"
              label="Tipo"
              rules={[{ required: true, message: 'Por favor seleccionar una opcion.' }]}
            >
              <Select
                placeholder="Seleccionar tipo"
                showSearch
                options={Object.values(PhoneType).map((type) => ({ label: type, value: type }))}
              />
            </Form.Item>
          </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item<PhoneFormInputs>
            name="country"
            label="Pais"
            rules={[{ required: true, message: 'Por favor ingresar pais.' }]}
          >
            <Select
              placeholder="Seleccionar pais"
              showSearch
              options={Object.entries(Countries).map(([code, name]) => ({ label: name, value: code }))}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<PhoneFormInputs>
            name="areaCode"
            label="Codigo de area"
            rules={[{ required: true, message: 'Por favor ingresar valor.' }]}
            style={{paddingLeft:'0.5em', paddingRight: '0.5em'}}
          >
            <InputNumber controls={false} style={{width:'100%'}}/>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<PhoneFormInputs>
            name="number"
            label="Numero"
            rules={[{ required: true, message: 'Por favor ingresar valor.' }]}
          >
            <InputNumber controls={false} style={{width:'100%'}}/>
          </Form.Item>
        </Col>
      </Row>
      </Form>
    </Modal>
  );
};
export default ModalPhones;
